import React, { useState, useCallback } from 'react';
import { apiCall } from '../../api/Interactor';
import { getListService } from '../../api/VenueInteractor';
import { AdjustmentsHorizontalIcon, MagnifyingGlassIcon, MapPinIcon } from '@heroicons/react/20/solid';
import { PencilIcon, PlusCircleIcon } from '@heroicons/react/24/solid';
import ListVenueSL from './skeletonviews/ListVenueSL';
import InfiniteScroll from 'react-infinite-scroller';
import { NavLink, useNavigate } from 'react-router-dom';
import { ReactSVG } from 'react-svg';

function ListVenue(props) {
  const navigate = useNavigate();
  const [listServices, setListServices] = useState([])
  const [nextPage, setNextPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const inputClass = "w-full text-sm bg-[#F5F5F5] rounded-lg py-2.5 px-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow"

  const getListServiceAPI = useCallback(
    async () => {

      if (loading) {
        return;
      }

      setLoading(true)

      getListService(nextPage,
        //success
        (responseJSON) => {
          setListServices([...listServices, ...responseJSON.venues])
          if (responseJSON.pagination.next_page !== "") {
            setNextPage(responseJSON.pagination.next_page)
          } else {
            setNextPage(null)
          }
          setLoading(false)
        },
        //failed
        (messages) => {
          setLoading(false)
        }
      )

    }, [listServices, loading, nextPage]
  )

  const openCloseVenueApi = (id) => {
    apiCall(
      "POST", process.env.REACT_APP_VENUE_OPEN_CLOSED,
      {
        id: id
      },
      (response) => {
        console.log(response);
        window.location.reload();
      },
      (message) => {
      }
    );
  };

  const activeInactiveVenueApi = (id) => {
    apiCall(
      "POST", process.env.REACT_APP_VENUE_ACTIVE_INACTIVE,
      {
        id: id
      },
      (response) => {
        console.log(response);
        window.location.reload();
      },
      (message) => {
      }
    );
  };

  const hasMoreItems = !!nextPage

  const loader = (
    <div className='flex flex-col gap-4'>
      <ListVenueSL />
      <ListVenueSL />
      <ListVenueSL />
    </div>
  )



  const passingDataToCheckout = (venue) => ({
    venue: {
      id: venue.id,
      name: venue.name,
      isDP: venue.is_dp
    },
    package: venue
  });

  const renderListService = () => {
    return listServices.map((item) => {
      return (
        <a key={item.id} className=''>
          <div className='relative flex border border-gray-200 rounded-lg overflow-hidden '>
            <div className='p-2 w-3/5 flex flex-col ml-4 gap-y-1.5 mt-2 flex-grow'>

              <div className="flex items-center text-md font-bold">
                <p className='text-lg font-semibold mr-4'> {item.name}</p>

              </div>

              <div className='flex items-center'>
                <p className='ml-1 text-sm text-gray-600'> {item.sport_type} </p>

              </div>

              <div className='flex-grow'></div>

              <div className='flex flex-row flex-grow  item-end'>

                {/* <div className='flex flex-grow gap-x-6'>
                  <div className='flex flex-col'>
                    <div className="flex items-center text-md font-bold">Total Sesi</div>
                    <div className="flex items-center text-md font-semibold mt-2">40 Sesi</div>
                  </div>
                  <div className='flex flex-col'>
                    <div className="flex items-center text-md font-bold">Laku</div>
                    <div className="flex items-center text-md font-semibold mt-2">24 Sesi</div>
                  </div>
                  <div className='flex flex-col'>
                    <div className="flex items-center text-md font-bold">Belum Laku</div>
                    <div className="flex items-center text-md font-semibold mt-2">6 Sesi</div>
                  </div>

                </div> */}


                <div className='flex flex-wrap gap-x-4 mb-2 mr-4'>
                  {/* <a href={'/venue/schedule/' + item.id}>
                    <button className='flex items-center px-4 py-2 gap-x-2 border border-primaryRed rounded-xl  text-xs text-primaryRed font-bold'>
                      <img src='/ic-calendar.svg' className=' w-6 h-6' />
                      Jadwal
                    </button>
                  </a> */}
                  <NavLink to={'/venue/schedule/' + item.id}>
                    <div className="flex items-center px-4 py-2 gap-x-2 border border-primaryRed rounded-xl  text-xs text-primaryRed font-bold">
                      <img src='/ic-calendar.svg' className=' w-6 h-6' />
                      Jadwal
                    </div>
                  </NavLink>

                  <a href={'/venue/edit/' + item.id}>
                    <button className='flex items-center px-4 py-2 gap-x-2 border border-primaryRed rounded-xl  text-xs text-primaryRed font-bold'>
                      <img src='/ic-pen.svg' className=' w-6 h-6' />
                      Edit
                    </button>
                  </a>
                  <div onClick={() => { openCloseVenueApi(item.id) }}>
                    <button className='flex items-center px-6 py-3 gap-x-2 border border-primaryRed rounded-xl  text-xs text-primaryRed font-bold'>
                      {item.is_closed === true && (<>Buka</>)}
                      {item.is_closed === false && (<>Tutup</>)}
                    </button>
                  </div>

                  <div onClick={() => { activeInactiveVenueApi(item.id) }}>
                    <button className='flex items-center px-6 py-3 gap-x-2 border border-primaryRed rounded-xl  text-xs text-primaryRed font-bold'>
                      {item.is_active === true && (<>Nonaktifkan</>)}
                      {item.is_active === false && (<>Aktifkan</>)}
                    </button>
                  </div>

                </div>

              </div>

            </div>
            </div>
        </a>
      )
    })
  }

  return (
      <div className="w-full h-full bg-white rounded-2xl flex flex-col px-6 py-6">
            {/* Header Section */}
            <div className="flex items-center justify-between mt-4">
              <p className="text-lg font-semibold text-gray-800">Lapang</p>
      
              <a href="/venue">
                <button className="flex items-center px-6 py-2 text-xs text-white bg-primaryRed rounded-md">
                  <PlusCircleIcon className="w-5 h-5 mr-2" />
                  Buat Lapang Baru
                </button>
              </a>
            </div>

      <div className="flex flex-col flex-1 gap-y-4 w-full">
        <InfiniteScroll loadMore={getListServiceAPI} hasMore={hasMoreItems}>
          {listServices.length > 0 ? (
            <div className='flex flex-col flex-1 mt-8 gap-y-4 w-full'>
              {renderListService()}
            </div>
          ) : (
              <div className="flex flex-1 flex-col mt-8 items-center justify-center w-full border border-gray-200 rounded-lg overflow-hidden text-center px-4 py-6 text-sm text-gray-600">
              <img src="/il-empty-novenueschedule.png" alt="Empty State" className="w-[260px] mb-4" />
              <span className='text-[#898989] text-lg font-semibold mb-4'>Lapang</span>
              <span className='text-[#898989]'>
                Tidak ada data yang ditampilkan karena belum ada lapang dibuat,<br></br>
                silahkan buat lapang baru dengan klik tombol di atas.
              </span>
            </div>

          )}
        </InfiniteScroll>
      </div>
    </div>
  );
}

export default ListVenue;